import React, {useCallback, useState} from 'react';
import MixPanelWrapper from 'js/servises/MixPanelWrapper';
import Heading from 'js/components/Common/Heading/Heading';
import Thumbnail from 'js/components/Common/Thumbnail/Thumbnail';
import Description from 'js/components/Common/Description/Description';
import PublishingDate from 'js/components/Common/PublishingDate/PublishingDate';
import ProductLabelsList from 'js/components/Common/ProductLabelList/ProductLabelsList';
import VisibilityViewerIcon from 'js/components/Common/VisibilityViewerIcon/VisibilityViewerIcon';

import Label from '../../components/Label/Label';
import {updateDownloadsQueryManual} from './ManualFetchData';
import Downloads from 'js/components/Common/ActivityCounter/Downloads';
import useFetchCallback from 'js/hooks/useFetchCallback/useFetchCallback';
import commonClasses from '../../../SearchResultsItem/SearchResultsItem.module.pcss';
import parse from 'html-react-parser';

export interface Props {
    data: {
        id: number,
        file: string,
        title: string,
        type: 'manuals',
        language: string,
        thumbnail: string,
        downloads: number,
        description: string,
        publishingDate: string,
        isRelease: boolean
    },
    isPromoted: boolean,
    isAISearch: boolean
}

const Manual = ({data, isPromoted, isAISearch}: Props) => {
    const {title, description, publishingDate, downloads, id, file} = data || {};
    const [itemDownloads, setItemDownloads] = useState<number>(downloads);

    const sendMixPanelEvent = useCallback(async () => {
        await MixPanelWrapper.TrackEvent(
            'Download Manual',
            {
                category: 'Search Results',
                value: data?.title,
                searchType: isAISearch ? 'AI' : 'Regular'
            });
    }, [data, isAISearch]);

    const fileDownloadHandler = useFetchCallback({
        updateData: val => val?.manualsSingle?.updateDownloads,
        query: () => updateDownloadsQueryManual(id),
        onStart: async () => {
            const element = document.createElement('a');
            element.setAttribute('href', file);
            const ext = file.split('.').pop();
            element.setAttribute('download', `${parse(title)}.${ext}`);

            element.style.display = 'block';
            element.click();
            setItemDownloads(prev => prev + 1);
            await sendMixPanelEvent();
        },
        onFailure: () => {
            console.error('Error while downloading');
        },
        onError: (e) => {
            console.error(e);
        }
    });
    return (
        <div className={`${commonClasses.SearchResultItem} ${isPromoted && commonClasses.Promoted}`}>
            <Thumbnail additionalClass={commonClasses.Thumbnail} type={'manuals'} alt={data?.title} />
            <span className={commonClasses.SearchResultItemInfo}>
                <div className={commonClasses.SearchResultItemInfoTop}>
                    <div className={commonClasses.TitleWrap}>
                        <div className={commonClasses.DownloadButton} onClick={fileDownloadHandler}>
                            <Heading text={`${title}`} type={'h5'}/>
                        </div>
                        <VisibilityViewerIcon
                            id={data?.id}
                        />
                    </div>
                    <Description data={description}/>
                    <ProductLabelsList pageId={data?.id}/>
                </div>
                <div className={commonClasses.Wrap}>
                    <Label type={'manuals'}/>
                    <Downloads count={itemDownloads}/>
		            <PublishingDate data={publishingDate}/>
                </div>
            </span>
        </div>
    );
};

export default Manual;
